import { api } from "../../../../helper/api";
import { DocumentCategory, DocumentUI } from "../entity/document.model";

function getDocuments(): Promise<DocumentUI[]> {
  return api.get("/mo/documents");
}

function getDocumentCategories(): Promise<DocumentCategory[]> {
  return api.get("/mo/documents/categories");
}

function deleteDocument(uuid: string): Promise<DocumentUI> {
  return api.delete(`/mo/documents/${uuid}`);
}

function getDocument(uuid: string): Promise<DocumentUI> {
  return api.get(`/mo/documents/${uuid}`);
}

function editDocument(document: DocumentUI): Promise<DocumentUI> {
  return api.put(`/mo/documents/`, document);
}

function addDocument(document: DocumentUI): Promise<DocumentUI> {
  return api.post(`/mo/documents/`, document);
}

export const documentService = {
  getDocuments,
  deleteDocument,
  getDocument,
  editDocument,
  addDocument,
  getDocumentCategories,
};
